var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgIcBook32Dp = function SvgIcBook32Dp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14 3c.8 0 1.5.3 2 .8.5-.5 1.2-.8 2-.8h10c.6 0 1 .4 1 1h2c.6 0 1 .4 1 1v23c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1V5c0-.6.4-1 1-1h2c0-.6.4-1 1-1zm16 3h-1v18c0 .6-.4 1-1 1H18c-.6 0-1 .4-1 1s-.4 1-1 1h14V6zM3 6H2v21h14c-.6 0-1-.4-1-1s-.4-1-1-1H4c-.6 0-1-.4-1-1V6zm11-1H5v18h9c.8 0 1.5.3 2 .8.5-.5 1.2-.8 2-.8h9V5h-9c-.6 0-1 .4-1 1s-.4 1-1 1-1-.4-1-1-.4-1-1-1zm2 4c.6 0 1 .4 1 1v9c0 .6-.4 1-1 1s-1-.4-1-1v-9c0-.6.4-1 1-1zm-4 8c.6 0 1 .4 1 1s-.4 1-1 1H8c-.6 0-1-.4-1-1s.4-1 1-1zm12 0c.6 0 1 .4 1 1s-.4 1-1 1h-4c-.6 0-1-.4-1-1s.4-1 1-1zm-12-4c.6 0 1 .4 1 1s-.4 1-1 1H8c-.6 0-1-.4-1-1s.4-1 1-1zm12 0c.6 0 1 .4 1 1s-.4 1-1 1h-4c-.6 0-1-.4-1-1s.4-1 1-1zM12 9c.6 0 1 .4 1 1s-.4 1-1 1H8c-.6 0-1-.4-1-1s.4-1 1-1zm12 0c.6 0 1 .4 1 1s-.4 1-1 1h-4c-.6 0-1-.4-1-1s.4-1 1-1z"
  })));
};

export default "/_next/static/ic_book_32dp-8e64ee891c3404e1a57235e422d6abeasvg";
export { SvgIcBook32Dp as ReactComponent };